import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty';

export const GET_SETTINGS_CONFIG_LOADING = "GET_SETTINGS_CONFIG_LOADING";
export const GET_SETTINGS_CONFIG_SUCCESS = "GET_SETTINGS_CONFIG_SUCCESS";
export const GET_SETTINGS_CONFIG_FAILED = "GET_SETTINGS_CONFIG_FAILED";
export const GET_SETTINGS_CONFIG_SUCCESS_PAGINATE = "GET_SETTINGS_CONFIG_SUCCESS_PAGINATE";

export const GET_FILTERED_SETTINGS_CONFIG_LOADING = "GET_FILTERED_SETTINGS_CONFIG_LOADING";
export const GET_FILTERED_SETTINGS_CONFIG_SUCCESS = "GET_FILTERED_SETTINGS_CONFIG_SUCCESS";

export const DELETE_SETTINGS_CONFIG_SUCCESS = "DELETE_SETTINGS_CONFIG_SUCCESS";
export const PAUSE_SETTINGS_CONFIG_SUCCESS = "PAUSE_SETTINGS_CONFIG_SUCCESS";
export const RESUME_SETTINGS_CONFIG_SUCCESS = "RESUME_SETTINGS_CONFIG_SUCCESS";

export const CLEAR_SETTINGS_CONFIG = "CLEAR_SETTINGS_CONFIG";
export const CLEAR_SETTINGS_CONFI_STATUS = "CLEAR_SETTINGS_CONFI_STATUS";

export const fetchConfigSettings = (limit: number, offset: number, paginate:boolean = false, search:string = "", total:number = 0) => {
    return (dispatch: Dispatch<any>) => {

        let URL = `/verify/settings?limit=${limit}&offset=${offset*limit}`;

        if(search && search.length){
            URL += `&title=${search}`;
        }

        let loadingType = GET_SETTINGS_CONFIG_LOADING;
        let successType = GET_SETTINGS_CONFIG_SUCCESS;

        if(total){
            loadingType = GET_FILTERED_SETTINGS_CONFIG_LOADING;
            successType = GET_FILTERED_SETTINGS_CONFIG_SUCCESS;
        }

        if(paginate){
            loadingType = "";
            successType = GET_SETTINGS_CONFIG_SUCCESS_PAGINATE;
        }

        dispatch({ type: loadingType, payload: {}});

        networkCall('get', URL, apiBaseUrl.baseUrl).then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({ type: successType, payload: {respose: res}});
            }else{
                dispatch({ type: GET_SETTINGS_CONFIG_FAILED, payload: {error: res}});
            }
        }).catch((err)=>{
            if(err?.response?.data){
                dispatch({ type: GET_SETTINGS_CONFIG_FAILED, payload: {error: err.response.data}});
            }
        });
    }
}

export const updateConfigSettings = (configId:string, updateStatus:number, cb:(msg:string)=>void) => {
    return (dispatch: Dispatch<any>) => {

        let actType:string = "";
        let status:number = 0;
        if(updateStatus === 1){
            actType = DELETE_SETTINGS_CONFIG_SUCCESS; 
            status = 9;
        }else if(updateStatus === 2){
            actType = PAUSE_SETTINGS_CONFIG_SUCCESS;
            status = 5;
        }else if(updateStatus === 3){
            actType = RESUME_SETTINGS_CONFIG_SUCCESS;
            status = 1;
        }

        let dataToSend = {
            setting_id: configId,
            status: status
        }

        networkCall("put", `/verify/settings-status`, apiBaseUrl.baseUrl, true, true, dataToSend).then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({ type: actType, payload: {id: configId}});
                cb(res.message);
            }else{
                dispatch({ type: GET_SETTINGS_CONFIG_FAILED, payload: {error: res}});
            }
        }).catch((err)=>{
            if(err?.response?.data){
                dispatch({ type: GET_SETTINGS_CONFIG_FAILED, payload: {error: err.response.data}});
            }
        });
    }
}

export const clearConfigSettings = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({type: CLEAR_SETTINGS_CONFIG});
    }
}

export const clearConfigSettingsStatus = () => {
    return (dispatch: Dispatch<any>) => {
        dispatch({type: CLEAR_SETTINGS_CONFI_STATUS});
    }
}